import { FeaturedTrialItemType } from '../Carousel/Carousel.types';

export type TrialCard = FeaturedTrialItemType;

export interface FilterChipsProps {
  items: TrialCard[];
  onFilterChange: (filteredItems: TrialCard[]) => void;
}

export const ALL_STUDIES_LABEL = 'All Studies';
